import $ from "jquery";
import "./../styles/main.scss";
import GLightbox from "glightbox";
require('./woocommerce/Global');
require('./helpers/CookieConsent');
require('./helpers/SliderWrapper');
require('./helpers/CarouselWrapper');
require("jquery.scrollto");
$(document).ready(function () {
    if ($('.glightbox').length) {
        GLightbox({
            touchNavigation: false,
            touchFollowAxis: false,
            keyboardNavigation: false
        });
    }
    $("body").on("click", "a[data-goto]", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            var posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    var lastScrollTop = 0;
    $(window).scroll(function () {
        var st = $(window).scrollTop();
        if (st > 250) {
            if (st > lastScrollTop) {
                $('#main-header').addClass('hide');
            }
            else {
                $('#main-header').removeClass('hide');
            }
        }
        else {
            $('#main-header').removeClass('hide');
        }
        lastScrollTop = st;
    });
});
